export const urlConfig={
	"apiBaseURL": "https://api.github.com"
}